<template>
	<div class="container justify-content-center pb-5">
		<div class="delu-text-large title-text">{{ $t("labels.returning") }}</div>
		<!-- <img src="@/assets/triangle.png" class="triangle-image" /> -->
		<div class="profile-card mt-3 p-5">
			<h1 class="nowrap"><i class="fab mr-2" :class="{ [`fa-${platform}`]: true }" />{{ platformDisplay }}</h1>
			<pre class="mt-5 error-block" v-html="errorMsg"></pre>
			<a class="btn btn-secondary mt-4" @click="closeWindow">{{ $t("labels.back") }}</a>
		</div>
	</div>
</template>

<script>
export default {
	name: "Return",

	props: [],

	components: {},

	data() {
		return {
			platformDisplay: "Delutaya.club",
			platform: "replyd",
			errorMsg: "Returned from Delutaya.club",
		};
	},

	created() {
		if (this.$route.query.platform) {
			this.platform = this.$route.query.platform;
			this.platformDisplay = this.platform;
			if (this.platformDisplay.length > 0) {
				this.platformDisplay = this.platformDisplay.charAt(0).toUpperCase() + this.platformDisplay.slice(1);
			}
			this.errorMsg = "Returned from " + this.platformDisplay;
		}

		let authToken = this.$route.query.hash;

		let domain = `${window.location.protocol}//${window.location.hostname}`;
		if (!(window.location.port == "80" || window.location.post == "443")) {
			domain += ":" + window.location.port;
		}

		setTimeout(() => {
			this.errorMsg =
				"Failed to return to the page you came from.<br />Please close this window and then refresh the main page manually.";
		}, 2000);

		console.log(window.opener);
		if (window.opener) {
			this.errorMsg = `Returned from ${this.platformDisplay}: ${window.opener.location}`;
			window.opener.postMessage(
				{
					type: "loginReturn",
					hash: authToken,
				},
				domain
			);
			window.close();
		}
	},

	methods: {
		closeWindow() {
			window.close();
		},
	},
};
</script>

<style scoped>
.title-text {
	color: #fff;
	text-align: center;
	font-family: "lato", sans-serif;
	font-weight: 500;
	font-size: 50px;
	letter-spacing: 4px;
	padding-left: 10px;

	background: -webkit-linear-gradient(white, #016922);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}
.delu-text-large {
	color: rgb(79, 211, 89);
	text-shadow: 0 0 5px rgb(79, 211, 89);
	font-size: 42px;
}
.error-block {
	overflow-x: auto;
	white-space: pre-wrap;
	white-space: -moz-pre-wrap;
	white-space: -pre-wrap;
	white-space: -o-pre-wrap;
	word-wrap: break-word;
}
</style>